import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import { root } from "./ProductCard.styles";
import { SizeContext } from "../../../atoms/contexts/SizeContext";
import { any, string } from 'prop-types';

/*
  maxSize: array of sm,md,lg
 */
var ProductCard = function ProductCard(props) {
  var _props$sizes = props.sizes,
    sizes = _props$sizes === void 0 ? ['sm', 'md', 'lg'] : _props$sizes,
    _props$link = props.link,
    link = _props$link === void 0 ? '#' : _props$link,
    disabled = props.disabled,
    children = props.children,
    _props$target = props.target,
    target = _props$target === void 0 ? '_self' : _props$target,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? function () {} : _props$onClick;
  if ((sizes === null || sizes === void 0 ? void 0 : sizes.length) === 0) return null;
  var rootSizes = root[sizes[0]];
  return /*#__PURE__*/React.createElement(SizeContext.Provider, {
    value: {
      sizes: sizes
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: link,
    target: target,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Grid, {
    p: 4,
    _hover: {
      boxShadow: 'xl'
    },
    transition: "box-shadow 200ms ease-in",
    columnGap: "1rem",
    rowGap: "0.2rem",
    "data-class": "product-card",
    sx: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rootSizes), sizes.includes('md') && {
      '@media(min-width: 768px)': root.md
    }), sizes.includes('lg') && {
      '@media(min-width: 1024px)': root.lg
    }), disabled && {
      opacity: '0.5'
    })
  }, children)));
};
ProductCard.Image = function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(GridItem, {
    position: "relative",
    area: "img"
  }, children);
};
ProductCard.Title = function (_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(GridItem, {
    area: "title"
  }, children);
};
ProductCard.Extra = function (_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(GridItem, {
    area: "extra"
  }, children);
};
ProductCard.Price = function (_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(GridItem, {
    area: "price"
  }, children);
};
export { ProductCard };
ProductCard.Image.propTypes = ProductCard.Title.propTypes = ProductCard.Extra.propTypes = ProductCard.Price.propTypes = {
  children: any
};